import { FC } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { numberToCurrencyString } from 'further-ui/utils';
import { CurrencyCode } from 'further-types/lp/vehicle';
import getColumns from './getColumns';
import AccountingTable from '../components/AccountingTable';
import AccountingFooter from '../components/AccountingFooter';

const TableWrapper = styled(Box)({
  '& .MuiTableCell-root:first-of-type': {
    paddingLeft: 0,
  },
});

type Props = {
  baseCurrency: CurrencyCode;
  isGroupByGlAccount: boolean;
  totalDebitsYtd: number;
  totalCreditsYtd: number;
  isLoading: boolean;
};

const TrialBalanceTotal: FC<Props> = ({
  baseCurrency,
  isGroupByGlAccount,
  totalDebitsYtd,
  totalCreditsYtd,
  isLoading,
}) => {
  const columns = getColumns(baseCurrency, isGroupByGlAccount);

  return (
    <AccountingFooter>
      <TableWrapper>
        <AccountingTable
          columns={columns}
          rows={[]}
          borderless
          hideHeader
          displayFooterIfEmptyTable
          bodyRowFontSize={14}
          bodyRowLineHeight={22}
          bodyRowPaddingY={0}
          customFooterRow={[
            {
              key: 'total',
              content: (
                <Typography variant="h6" color="grey.600">
                  Total
                </Typography>
              ),
              colspan: isGroupByGlAccount ? 4 : 5,
            },
            {
              key: 'debitsYtd',
              content: (
                <Typography variant={isLoading ? 'body2' : 'h6'}>
                  {isLoading
                    ? '--'
                    : numberToCurrencyString(totalDebitsYtd, {
                        currency: baseCurrency,
                        negativeInBrackets: true,
                      })}
                </Typography>
              ),
            },
            {
              key: 'creditsYtd',
              content: (
                <Typography variant={isLoading ? 'body2' : 'h6'}>
                  {isLoading
                    ? '--'
                    : numberToCurrencyString(totalCreditsYtd, {
                        currency: baseCurrency,
                        negativeInBrackets: true,
                      })}
                </Typography>
              ),
              colspan: 3,
            },
          ]}
        />
      </TableWrapper>
    </AccountingFooter>
  );
};

export default TrialBalanceTotal;
